import { render, staticRenderFns } from "./CompanyBuilder.vue?vue&type=template&id=850463da&scoped=true"
import script from "./CompanyBuilder.vue?vue&type=script&lang=js"
export * from "./CompanyBuilder.vue?vue&type=script&lang=js"
import style0 from "./CompanyBuilder.vue?vue&type=style&index=0&id=850463da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "850463da",
  null
  
)

export default component.exports